/**
 * Section configuration
 */
module.config(['$stateProvider', function ($stateProvider) {
    'use strict';
    $stateProvider
        .state('internship.detail', {
            url: '/{slug}--{id}?{location}{internship}',
            controller: [
                '$scope', '$rootScope', '$filter', 'lodash', '$location', '$http', 'drupal', '$stateParams', '$state', 'headermanager', 'tools', 'NgMap', '$timeout', 'cart', 'pattern',
                function ($scope, $rootScope, $filter, lodash, $location, $http, drupal, $stateParams, $state, $headermanager, tools, NgMap, $timeout, $cart, pattern) {
                    $scope.tools = tools;
                    $scope.loading = true;
                    $scope.pending = false;
                    $scope.accommodation_link = null;
                    $scope.pattern = pattern;

                    // expose site config
                    $scope.configSite = $rootScope.config.site;
                    $scope.checknotranlate = function(text) {
                        if($scope.pattern.noTranslatePattern.test(text)){
                            return "no"
                        } else {
                            return "yes"
                        }
                    }
                    // build  breadcrumb
                    $scope.breadcrumb = [
                        {label: $filter('translate')('home'), state: 'homepage'},
                        {label: $filter('translate')('internship.title'), state: 'internship.list'}
                    ];

                    // titlepanel
                    $scope.pricingInfo = {};

                    $headermanager.customize({
                        filled: true
                    });

                    // internship area
                    $scope.areaMessage = {
                        message: '',
                        defaultMessage: '',
                        isDefault: false, // flag to replace areaMessage by config message (async)
                    };

                    // Init form data
                    $scope.data = {};

                    // Init calendar data
                    $scope.calendarData = {
                        selectedReservation: {}
                    };

                    // Init expand components
                    $scope.expandsData = {
                        reservationSelect: {
                            isOpen: true,
                            isEnabled: true
                        }
                    };

                    // Shop widget mock
                    $scope.shopSlideshowContent = {
                        title: '',
                        field_teaser: ''
                    };

                    var configWatcher = $rootScope.$watchCollection('config.site', function(value) {
                        if (value) {
                            if (value.bloc_produits_text) {
                                angular.merge($scope.shopSlideshowContent, {title: value.title_bloc});
                            }
                            if (value.bloc_internship_header && value.bloc_internship_header.multiple_area_text) {
                                var message = ['•', value.bloc_internship_header.multiple_area_text].join(' ');
                                if ($scope.areaMessage.isDefault) {
                                    angular.merge($scope.areaMessage, {message: message, defaultMessage: message});
                                } else {
                                    angular.merge($scope.areaMessage, {defaultMessage: message});
                                }
                            }
                            $scope.updateBaseLink();
                        }
                    });

                    $scope.$on('$destroy', function () {
                        configWatcher();
                    });

                    drupal.getInternships($stateParams.id).then(function(internships) {
                        if (internships.length === 0) {
                            $state.go('internship.list');
                            return;
                        }
                        if (internships && internships.length > 0) {
                            $scope.product = angular.copy(internships[0].product);
                            $scope.breadcrumb.push({label: $scope.product.name});

                            $scope.visuals = [];

                            if ($scope.product.page) {
                                var mainVisual = ($scope.product.page.field_background_visual && $scope.product.page.field_background_visual[0]) || ($scope.product.page.field_theme && $scope.product.page.field_theme.field_background_visual && lodash.sample($scope.product.page.field_theme.field_background_visual));

                                if (mainVisual) {
                                    $headermanager.customize({
                                        filled: true,
                                        picture: { type: 'image', src: mainVisual.src, styles: mainVisual}
                                    });
                                }

                                $scope.visuals = $scope.visuals.concat($scope.product.page.field_visuals);
                                console.log('$scope.product.page', $scope.product.page);
                                console.log('$scope.visuals', $scope.visuals);
                                console.log('$scope.product.page.field_theme && $scope.product.page.field_theme.field_visuals', $scope.product.page.field_theme && $scope.product.page.field_theme.field_visuals);
                                if ($scope.product.page.field_theme && $scope.product.page.field_theme.field_visuals) {
                                    console.log('$scope.product.page.field_theme.field_visuals)', $scope.product.page.field_theme.field_visuals);
                                    $scope.visuals = $scope.visuals.concat($scope.product.page.field_theme.field_visuals);
                                    console.log('$scope.visuals', $scope.visuals);
                                }
                            }

                            var boats = {};
                            $scope.product.fleet = [];

                            var bases = {};
                            $scope.product.bases = [];
                            var areas = [];

                            internships.forEach(function(internship) {
                                internship.fleet.forEach(function(boat) {
                                    if (!boats.hasOwnProperty(boat.sfid)) {
                                        $scope.product.fleet.push(boats[boat.sfid] = angular.copy(boat));
                                    }
                                });
                                if (!bases.hasOwnProperty(internship.base.base.sfid)) {
                                    var base = angular.copy(internship.base.base);
                                    base.internships = [];
                                    base.sites = {};
                                    bases[internship.base.base.sfid] = base;
                                    $scope.product.bases.push(base);
                                    if (!$stateParams.location) {
                                        $scope.data.base = base;
                                        $scope.changeLocation();
                                    }
                                    if (base.sfid === $stateParams.location) {
                                        $scope.data.base = base;
                                    }
                                }
                                if (!bases[internship.base.base.sfid].sites.hasOwnProperty(internship.base.site.sfid)) {
                                    var site = angular.copy(internship.base.site);
                                    bases[internship.base.base.sfid].sites[site.sfid] = site;
                                }
                                bases[internship.base.base.sfid].internships.push(internship);
                                bases[internship.base.base.sfid].durationMin = Math.min(bases[internship.base.base.sfid].durationMin || Number.MAX_VALUE, internship.duration);
                                bases[internship.base.base.sfid].durationMax = Math.max(bases[internship.base.base.sfid].durationMax || Number.MIN_VALUE, internship.duration);

                                $scope.product.accommodation = internship.accommodation;

                                if (internship.area) {
                                    areas.push(internship.area);
                                }

                                if (internship.sfid === $stateParams.internship && internship.stock > 0) {
                                    $scope.calendarData.selectedReservation = internship;
                                }
                            });

                            if (!$scope.data.base) {
                                // unmatch base sfid
                                $scope.data.base = $scope.product.bases[0];
                                $scope.changeLocation();
                            }

                            $scope.updateHeaderPrice();
                            $scope.updateBaseLink();
                            $scope.updateMap();

                            // we check if there are multiple areas defined,
                            // if there are, we display a config message,
                            // if not, we display the name of area
                            var uniqArea = lodash.uniq(areas);

                            if (uniqArea.length === 1) {
                                angular.merge($scope.areaMessage, {isDefault: false, message: ['•', uniqArea[0]].join(' ')});
                            } else {
                                if (uniqArea.length && $scope.areaMessage.defaultMessage) {
                                    angular.merge($scope.areaMessage, {message: $scope.areaMessage.defaultMessage});
                                }
                                $scope.areaMessage.isDefault = !!uniqArea.length;
                            }

                            // Matomo tracking
                            if (window._paq) {
                                try {
                                    window._paq.push(['setEcommerceView',
                                        $scope.product.sfid,
                                        $scope.product.name,
                                        $scope.product.activity
                                    ]);
                                    _paq.push(['trackPageView']);
                                } catch (e) { console.error(e); }
                            }
                        }
                        $scope.loading = false;
                    });

                    $scope.getParticipants = function(internship) {
                        return tools.getRange(internship.privatizable?3:1, internship.stock);
                    };

                    $scope.changeLocation = function() {
                        // reset calendar reservation
                        $scope.editReservation();
                        $scope.updateHeaderPrice();
                        $scope.updateBaseLink();
                        $scope.updateMap();

                        $state.transitionTo('internship.detail', {id: $stateParams.id, slug: $stateParams.slug, location: $scope.data.base.sfid}, { notify: false });
                    };

                    $scope.updateMap = function() {
                        var latlng;
                        var bounds = new google.maps.LatLngBounds();
                        // add base info as bound
                        if ($scope.data.base.latitude && $scope.data.base.longitude) {
                            latlng = new google.maps.LatLng($scope.data.base.latitude, $scope.data.base.longitude);
                            bounds.extend(latlng);
                        }
                        for (var site in $scope.data.base.sites) {
                            // add each site info as bound
                            latlng = new google.maps.LatLng($scope.data.base.sites[site].latitude, $scope.data.base.sites[site].longitude);
                            bounds.extend(latlng);
                        }
                        NgMap.getMap().then(function(map) {
                            map.setCenter(bounds.getCenter());
                            map.fitBounds(bounds);
                        });
                    };

                    $scope.updateBaseLink = function() {
                        if (!$scope.data.base || ($scope.product && $scope.product.accommodation === 'Vie à bord')) {
                            $scope.accommodation_link = null;
                            return
                        }
                        const base = $scope.data.base.sfid;
                        const link = Object.values($rootScope.config.site.accommodation_links).find(function (link) {
                            return link.value === base;
                        });
                        $scope.accommodation_link = link ? link.url : null;
                    };

                    $scope.updateHeaderPrice = function () {
                        // filled pricing info
                        if ($scope.data.base) {
                            var discounted = lodash.chain($scope.data.base.internships).filter(function (i) { return i.stock > 0; }).min('discountPrice').value();
                            angular.merge($scope.pricingInfo, {
                                discount: discounted.discountPrice,
                                duo: discounted && discounted.product && discounted.product.duo
                            });
                        }
                    };

                     $scope.$on('accordion_opening', function(event, params) {
                        // force rendering if it is ngmap accordion
                        if (params.id_accordion === 'internshiplocation') {
                            NgMap.getMap().then(function(map) {
                                // Timeout seems necessary to let map time to adapt its size to the appearing div's one
                                $timeout(function() {
                                    $scope.updateMap();
                                }, 250);
                            });
                        }
                    });

                    // open google map (for route)
                    $scope.openGM = function (event, site) {
                        // remove cedex for gm query
                        var city = site.city.replace(/cedex/i,'').trim();
                        // prepare query (address, postal code and city)
                        var q = [site.address, site.postalCode, city].join('+').replace(/\s/g, '+');
                        window.open('https://www.google.com/maps/dir/?api=1&origin='+encodeURI(q));
                    };

                    $scope.$watch('calendarData.selectedReservation', function(value) {
                        if (!tools.isEmptyObject(value)) {
                            $scope.calendarData.selectedReservation.open = true;
                            $scope.data.participantsSelect = $scope.calendarData.selectedReservation.privatizable?'3':'1';
                            // eval privatization
                            $scope.data.privatize = $scope.calendarData.selectedReservation.privatizable && $scope.calendarData.selectedReservation.privatizableOnly;
                        }
                    });

                    // Edit link that let the user change the reservation's date
                    $scope.editReservation = function(event) {
                        if (event) {
                            event.stopPropagation();
                        }
                        $scope.calendarData.selectedReservation = {};
                        $scope.expandsData.reservationSelect.isOpen = true;
                    };

                    $scope.$on('accordion_opening', function(event) {
                        NgMap.getMap().then(function(map) {
                            // Timeout seems necessary to let map time to adapt its size to the appearing div's one
                            $timeout(function() {
                                var center = map.getCenter();
                                google.maps.event.trigger(map, 'resize');
                                map.setCenter(center);
                            }, 1000);
                        });
                        event.stopPropagation();
                    });

                    $scope.addToCart = function () {
                        if (!$scope.pending) {
                            $scope.pending = true;
                            $cart.addInternship($scope.calendarData.selectedReservation, {
                                    field_privatized: $scope.data.privatize,
                                    field_participants: parseInt($scope.data.participantsSelect)
                                })
                                .then(function () {
                                    $scope.pending = false;
                                });
                        }
                    };
                }
            ],
            templateUrl: 'src/views/internship/internship.html'
        });
}]);
